import { getAccessToken } from './access-token';

async function extractFile(url, name) {
  if (url && name) {
    try {
      const response = await fetch(url, { method: 'get' });
      const blob = await response.blob();
      const link = document.createElement('a');
      const href = window.URL.createObjectURL(blob);
      link.href = href;
      link.setAttribute('download', name);
      link.setAttribute('target', '_blank');
      link.click();
      window.URL.revokeObjectURL(href);
      return response;
    } catch (error) {
      return error.response;
    }
  }
}

// use only for special cases
// like this one with response header Transfer-encoding: chunked

async function fetchAndDownloadPdf(url, fileName = 'file.pdf', form) {
  // eslint-disable-next-line no-undef
  const baseURL = process.env.REACT_APP_API_AGENTSPACE_SERVICE;
  const accessToken = getAccessToken();
  const requestHeaders = new Headers();
  requestHeaders.append('Authorization', `Bearer ${accessToken ?? ''}`);
  // Step 1: Fetch the response
  const response = await fetch(`${baseURL}${url}`, {
    method: 'POST',
    headers: requestHeaders,
    body: JSON.stringify(form),
  });

  // Step 2: Ensure the response is OK
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  // Step 3: Read the response body stream
  const reader = response.body.getReader();
  const chunks = []; // To store the chunks of binary data

  // Step 4: Process the chunks
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    chunks.push(value);
  }

  // Step 5: Combine chunks into a single Uint8Array
  const fullBuffer = new Uint8Array(chunks.reduce((acc, chunk) => acc + chunk.length, 0));
  let offset = 0;
  for (let chunk of chunks) {
    fullBuffer.set(chunk, offset);
    offset += chunk.length;
  }

  // Step 6: Create a Blob from the Uint8Array
  const blob = new Blob([fullBuffer], { type: 'application/pdf' });

  // Step 7: Trigger the download
  const link = document.createElement('a');
  const href = URL.createObjectURL(blob);
  link.href = href;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
  return response;
}

async function blobDownload(blob, fileName) {
  if ((!blob && !fileName) || !blob || !fileName) return;
  try {
    const link = document.createElement('a');
    const href = URL.createObjectURL(blob);
    link.href = href;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  } catch (error) {
    return error.response;
  }
}

function downloadFile(file, fileName) {
  try {
    if (!file) return;
    const link = document.createElement('a');
    // convert response data blob to object url
    const objectUrl = URL.createObjectURL(file);
    link.href = objectUrl;
    link.download = fileName || 'download';
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
  } catch (error) {
    console.error('Error occurred while downloading file');
  }
}

export { extractFile, fetchAndDownloadPdf, blobDownload, downloadFile };
